import { enResources } from "./translations.en";

export const resources = { en: enResources } as const;

export type AppLang = "en" | "ar";
